import { SettingsCategory } from './enums'
import type { AuthProviderType, OrganizationRole, SettingsNavCategory, ThemePreference } from './settings.interface'

export const VALID_SETTINGS_CATEGORIES = new Set<SettingsNavCategory['id']>([
  SettingsCategory.ACCOUNT,
  SettingsCategory.WORKSPACE,
  SettingsCategory.PROJECT,
])
export const ACCOUNT_SETTINGS_SUBPAGES = new Set(['organizations'])
export const DEFAULT_SETTINGS_CATEGORY: SettingsNavCategory['id'] = SettingsCategory.ACCOUNT
export const DEFAULT_SETTINGS_SUBPAGE = 'general'

export const GRAFTS = {
  CREATED: 'CREATED',
  FAILED: 'FAILED',
  UPDATED: 'UPDATED',
} as const

export const GATEWAYS_SERVICES = {
  CONFIG_CHANGED: 'CONFIG_CHANGED',
  CONNECTED: 'CONNECTED',
  LATENCY: 'LATENCY',
} as const

export const PACKAGES = {
  INSTALLED: 'INSTALLED',
  UPDATE: 'UPDATE',
  INSECURE: 'INSECURE',
} as const

export const DIGESTS = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
} as const

export const VULNERABILITIES = {
  WARNINGS: 'WARNINGS',
  CRITICAL: 'CRITICAL',
} as const

export const SYSTEM_ADMIN = {
  PERMISSIONS: 'PERMISSIONS',
  BILLING: 'BILLING',
} as const

export const NOTIFICATIONS = {
  GRAFTS,
  GATEWAYS_SERVICES,
  PACKAGES,
  DIGESTS,
  VULNERABILITIES,
  SYSTEM_ADMIN,
} as const

export const WORKSPACE_NOTIFICATION_CHANNEL = {
  EMAIL: 'email',
  IN_APP: 'inApp',
} as const

export const AuthProvider: Record<Uppercase<AuthProviderType>, AuthProviderType> = {
  GOOGLE: 'google',
  GITHUB: 'github',
} as const

export const DEFAULT_THEME: ThemePreference = 'system'

export const THEME_OPTIONS: { value: ThemePreference; label: string }[] = [
  { value: 'system', label: 'System' },
  { value: 'light', label: 'Light' },
  { value: 'dark', label: 'Dark' },
]

export const AUTH_PROVIDER_CONFIG = {
  google: { label: 'Google', iconVariant: 'google' as const },
  github: { label: 'GitHub', iconVariant: 'github' as const },
} as const

export const ORGANIZATION_ROLE = {
  DEVELOPER: 'Developer',
  ADMIN: 'Admin',
  OWNER: 'Owner',
} as const satisfies Record<Uppercase<OrganizationRole>, OrganizationRole>

export const VALID_ORGANIZATION_ROLES: OrganizationRole[] = [
  ORGANIZATION_ROLE.DEVELOPER,
  ORGANIZATION_ROLE.ADMIN,
  ORGANIZATION_ROLE.OWNER,
]
